import { Form, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { fetchCounties, fetchData } from "../../../features/fetch/fetchSlice";
import { numberWithCommas } from "../../../utils";

const Expenditure = () => {
  const url = "api/v2/dashboard/getProjectDashboardData";
  const { loading, count, data } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const [countyId, setCountyId] = useState(null);
  const dispatch = useDispatch();

  async function fetchDashData() {
    await dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
      })
    );
  }

  // useEffect(() => {
  //   dispatch(fetchCounties());
  // }, []);

  // useEffect(() => {
  //   fetchDashData();
  // }, [countyId]);

  const formatYAxisTicks = (tick) => {
    if (tick >= 1e9) {
      return `${(tick / 1e9).toFixed(1)}B`;
    }
    if (tick >= 1e6) {
      return `${(tick / 1e6).toFixed(1)}M`;
    }
    if (tick >= 1e3) {
      return `${(tick / 1e3).toFixed(1)}K`;
    }
    return tick;
  };

  const labelMap = {
    totalcost: "Total Cost",
    totalexpenditure: "Total Expenditure",
  };

  const colorMap = {
    totalcost: "#0092CC",
    totalexpenditure: "#16A34A",
  };

  const CustomLegend = ({ payload }) => {
    return (
      <div className="flex justify-start gap-2 mt-[.66rem]">
        {payload?.map((entry, index) => (
          <div
            key={`legend-item-${index}`}
            className="flex items-center gap-1 px-3 py-1 text-sm"
            style={{ backgroundColor: "#fff" }}
          >
            <div
              className="w-3 h-3 rounded-full"
              style={{ backgroundColor: entry?.color }}
            ></div>
            <span>{labelMap[entry?.value] || entry?.value}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white w-full h-full">
      <div className="flex items-center justify-between mb-[1rem]">
        <span className="text-[#424242] font-interSans text-[.75rem] font-[500]">
          Projects Expenditure
        </span>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data?.projectExpenditure}
          margin={{ top: 5, right: 0, left: -5, bottom: 25 }}
        >
          <CartesianGrid vertical={false} strokeDasharray="0" />
          <XAxis dataKey="year" axisLine={false} tickLine={false} />
          <YAxis
            axisLine={true}
            tickLine={false}
            tickFormatter={formatYAxisTicks}
          />
          <Tooltip
            cursor={{ fill: "transparent" }}
            content={({ payload, label }) => {
              if (!payload || !payload?.length) return null;
              return (
                <div className="bg-white shadow rounded p-2 text-sm">
                  <p className="font-medium">{label}</p>
                  {payload?.map((entry, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <div
                        className="w-3 h-3 rounded-full"
                        style={{ backgroundColor: entry?.color }}
                      ></div>
                      <span>
                        {labelMap[entry?.name] || entry?.name}:{" "}
                        {numberWithCommas(entry?.value)}
                      </span>
                    </div>
                  ))}
                </div>
              );
            }}
          />
          <Legend
            verticalAlign="bottom"
            align="start"
            content={<CustomLegend />}
          />
          <Bar dataKey="totalcost" fill={colorMap.totalcost} radius={[4, 4, 0, 0]} />
          <Bar dataKey="totalexpenditure" fill={colorMap.totalexpenditure} radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Expenditure;
